import { createContext } from 'react';
var RowContext = /*#__PURE__*/createContext({});
export default RowContext;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-layout/src/RowContext.js